import { CalendarDays, CalendarPlus, CreditCard, FileText, Home, House, MessageCircle, UserRound } from 'lucide-react';
import { lazy, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { RouteObject } from 'react-router';
import { PortalShell, useUnreadMessages, type NavItem } from '@/components/shell';

const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const BookPage = lazy(() => import('./pages/BookPage'));
const PropertiesPage = lazy(() => import('./pages/PropertiesPage'));
const PropertyFormPage = lazy(() => import('./pages/PropertyFormPage'));
const PropertyDetailPage = lazy(() => import('./pages/PropertyDetailPage'));
const CalendarPage = lazy(() => import('./pages/CalendarPage'));
const JobDetailPage = lazy(() => import('./pages/JobDetailPage'));
const QuotesPage = lazy(() => import('./pages/QuotesPage'));
const QuoteDetailPage = lazy(() => import('./pages/QuoteDetailPage'));
const PaymentsPage = lazy(() => import('./pages/PaymentsPage'));
const MessagesPage = lazy(() => import('./pages/MessagesPage'));
const AccountPage = lazy(() => import('./pages/AccountPage'));

function ClientLayout() {
  const { t } = useTranslation('client');
  const unread = useUnreadMessages();
  const nav: NavItem[] = [
    { to: '/client', label: t('nav.home'), icon: Home, end: true, primary: true },
    { to: '/client/reserver', label: t('nav.book'), icon: CalendarPlus, primary: true },
    { to: '/client/proprietes', label: t('nav.properties'), icon: House },
    { to: '/client/calendrier', label: t('nav.calendar'), icon: CalendarDays, primary: true },
    { to: '/client/soumissions', label: t('nav.quotes'), icon: FileText },
    { to: '/client/paiements', label: t('nav.payments'), icon: CreditCard },
    { to: '/client/messages', label: t('nav.messages'), icon: MessageCircle, badge: unread, primary: true },
    { to: '/client/compte', label: t('nav.account'), icon: UserRound },
  ];
  return <PortalShell nav={nav} title={t('nav.title')} homeTo="/client" />;
}

/** Client portal routes (mounted under /client). */
const clientRoutes: { element: ReactElement; children: RouteObject[] } = {
  element: <ClientLayout />,
  children: [
    { index: true, element: <DashboardPage /> },
    { path: 'reserver', element: <BookPage /> },
    { path: 'proprietes', element: <PropertiesPage /> },
    { path: 'proprietes/nouvelle', element: <PropertyFormPage /> },
    { path: 'proprietes/:id', element: <PropertyDetailPage /> },
    { path: 'proprietes/:id/modifier', element: <PropertyFormPage /> },
    { path: 'calendrier', element: <CalendarPage /> },
    { path: 'menages/:id', element: <JobDetailPage /> },
    { path: 'soumissions', element: <QuotesPage /> },
    { path: 'soumissions/:id', element: <QuoteDetailPage /> },
    { path: 'paiements', element: <PaymentsPage /> },
    { path: 'messages', element: <MessagesPage /> },
    { path: 'messages/:id', element: <MessagesPage /> },
    { path: 'compte', element: <AccountPage /> },
  ],
};
export default clientRoutes;
